import { render, staticRenderFns } from "./DdCalcTankaBox.vue?vue&type=template&id=370422ac&scoped=true&"
import script from "./DdCalcTankaBox.vue?vue&type=script&lang=js&"
export * from "./DdCalcTankaBox.vue?vue&type=script&lang=js&"
import style0 from "./DdCalcTankaBox.vue?vue&type=style&index=0&id=370422ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "370422ac",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VChip,VRow,VTooltip})
